export module Cookie {

    export function read(name: string, default_val?: string): string | null {
        var result = new RegExp("(?:^|; )" + encodeURIComponent(name) + "=([^;]*)").exec(document.cookie);
        if (result) {
            return result[1];
        }
        if (default_val === undefined) {
            default_val = null;
        }

        return default_val;
    }

    export function read_json_array(key: string): any[] | null {
        var result_str: string = read(key);
        if (result_str) {
            try {
                let r = JSON.parse(result_str);
                if (Array.isArray(r)) {
                    return r;
                }
                else {
                    console.error(`read_json_array encountered a malformed array ${result_str}`);
                }
            } catch (e) {
                console.error(e);
            }
        }
        return [];
    }

    export function write_bool(key: string, val: boolean) {
        let s_val: string = "false";
        if (val) {
            s_val = "true";
        }
        write(key, s_val);
    }
    export function write(name: string, value: string, days?: number) {
        if (!days) {
            days = 365 * 20;
        }

        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        var expires = "; expires=" + date.toUTCString();

        document.cookie = name + "=" + value + expires + "; path=/";
    }

    export function write_json(name: string, value: any, days?: number) {
        write(name, JSON.stringify(value), days);
    }
}